import React, { useEffect } from 'react';
import { generatePath, Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, Breadcrumbs, Paper, Typography } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../../rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import routes from '../../../routes';
import ModuleButtons from './ModuleButtons';
import { updateUserCourseModule } from '../../../actions/users';
import { VIDEO_MODULE_NAME } from '../LearningCenterMobile/LearningCenterMobileView';

const LearningCenterMobileVideoBreadcrumbs = ({ label }) => (
  <Box boxShadow={0}>
    <Breadcrumbs aria-label="breadcrumb">
      <StyledRescuerBreadcrumb
        component={Link}
        to={generatePath(routes.mobileDashboard)}
        label="Home"
        icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
      />
      <StyledRescuerTextBreadcrumb component={Link} to={generatePath(routes.mobileDashboardLearn)} label="Learn" />
      <StyledRescuerTextBreadcrumb component="a" href="#" label={label} />
    </Breadcrumbs>
  </Box>
);

const VideoModule = ({ userId, course, nextTab, setCurrentCoursesState, isMobile = false }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id, title, videoDuration: duration, transcript, video, modules = [] } = course;
  const module = modules.find((m) => m.name === VIDEO_MODULE_NAME);

  if (!id) {
    if (isMobile) {
      return history.push(generatePath(routes.mobileDashboardLearn));
    }
    return history.push(generatePath(routes.learn));
  }

  useEffect(() => {
    if (module.id && !module.completed) {
      dispatch(updateUserCourseModule(userId, id, module.id));
    }
    setCurrentCoursesState(id);
  }, [module]);

  return (
    <>
      {isMobile && <LearningCenterMobileVideoBreadcrumbs label={`${title}`} />}

      <Box
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
          backgroundColor: 'background.default',
          flexDirection: 'column',
          padding: 1,
        }}
      >
        <Typography variant="h6">
          {title} - {duration} min
        </Typography>

        <Paper sx={{ padding: 1, paddingBottom: 2, marginTop: 1 }}>
          <Box py={1}>
            <video src={video} width="100%" height="100%" controls style={{ maxWidth: '800px' }}>
              <track kind="captions" src="" />
              Your browser does not support the video.
            </video>
          </Box>

          <Typography variant="body1">Transcript</Typography>

          <Box
            sx={{
              border: '1px solid black',
              padding: 1,
              marginTop: 1,
              overflow: 'scroll',
              maxHeight: '300px',
            }}
          >
            <Typography variant="body2">{transcript}</Typography>
          </Box>
        </Paper>

        <ModuleButtons nextTab={nextTab} courseId={id} isMobile={isMobile} />
      </Box>
    </>
  );
};

export default VideoModule;
